<template>
    <div>
        <!-- <div class="filterBg">
            <el-form size="mini" :model="searchForm" label-position="right" label-width="120px" inline>
                <el-form-item label="卡号:">
                    <el-input v-model="searchForm.cardNumber" placeholder="请输入卡号" class="filter-item" clearable
                        @keyup.enter.native="handleFilter" @clear="handleFilter" />
                </el-form-item>
                <el-form-item label=" "> </el-form-item>
                <el-form-item label=" ">
                    <div style="float: right">
                        <el-button type="primary" icon="el-icon-search" @click="handleFilter">查询</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div> -->
        <div class="listTable">
            <div class="margins">
                <span>
                    <el-button @click="vectorPlot" class="base-button" size="mini" type="primary" icon="el-icon-plus">新增</el-button>
                    <!-- <el-button type="primary" @click="manageImport">导入</el-button>
                    <el-button type="primary" @click="downfileTransfer">导出</el-button> -->
                </span>
                <span>
                </span>
            </div>
            <YzTable @select="selectionRow" @select-all="handleSelectionChange" max-height="620px" :hasPage="false"
                :getData="checkAll" :afterRequest="afterRequest" :columnApi="columns" :listApi="listArray"
                :searchForm="searchForm" :autoLoad="true" ref="YzTable" />
        </div>
    </div>
</template>
  
<script>
let plotUti = undefined;
import vectorPlot from "../VectorPlot/index.vue" //矢量标绘
export default {
    data() {
        return {
            columns: "json/vectorPlot.json?v=2",
            listArray: "/mark/queryMyMarkList",
            searchForm: {
                page: 1,
                pageSize: 10,
                cardNumber: undefined
            },
            selectAll: []
        };
    },
    created() {
    },
    mounted() {
        this.$bus.$on("vectorPlot-list", () => {
            this.handleFilter();
        });

        plotUti = DBmap.plotUti;
        // if (!plotUti) {
        //     plotUti = new PlotManage({
        //         //callbackEdit: this.callbackEdit
        //     });
        // }

    },
    beforeDestroy() {
        this.$bus.$off("vectorPlot-list");
    },
    methods: {

        //矢量标绘
        vectorPlot() {
            var ins = this.$dialog.getDialog("矢量标绘");
            if (ins) {
                ins.reset();
                return;
            }
            this.$dialog.open({
                id: "矢量标绘",
                theme: "feature-dialog",
                title: "矢量标绘",
                area: {
                    height: "140px",
                    width: "70vw", //"1400px",
                },
                location: {
                    top: "80px",
                    left: "20px",
                },
                content: {
                    type: "vue",
                    subCom: vectorPlot,
                },
            });
        },
        selectionRow(selection, row) {
            let selected = selection.length && selection.indexOf(row) !== -1;
            plotUti.checkRow(row, selected);
        },
        handleSelectionChange(selection) {
            console.log(selection);
            if (selection.length > 0) {
                for (let i = 0; i < selection.length; i++) {
                    let row = selection[i];
                    plotUti.checkRow(row, true);
                }
            }
            if (selection.length < 1) {
                for (let i = 0; i < this.selectAll.length; i++) {
                    let row = this.selectAll[i];
                    plotUti.checkRow(row, false);
                }
            }
            this.selectAll = selection.slice();

        },
        afterRequest(res) {
            return {
                result: {
                    items: res.result,
                    total: 0
                }
            }
        },

        checkAll() {
            this.$nextTick(() => {
                var table = this.$refs["YzTable"].getInstance();
                var data = this.$refs["YzTable"].getInnerData();
                for (let i = 0; i < data.length; i++) {
                    let row = data[i];
                    let uuid = row.markId;
                    var entity = viewer.entities.getById(uuid);
                    if (entity && entity.show) {
                        table.toggleRowSelection(row, true);
                    }
                }
            });

        },
        handleFilter() {
            this.searchForm.page = 1;
            this.$refs["YzTable"].getList(this.searchForm, true);
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
    },
};
</script>